import script from "./cat24SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./cat24SideBar.vue?vue&type=script&setup=true&lang=js"

import "./cat24SideBar.vue?vue&type=style&index=0&id=76e5511e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e5511e"]])

export default __exports__